import { execSafeSaga } from '@lib/helpers';
import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import { setFreeCashBalance, actionType, setFunderDetail, setFunderAgreementUrl, } from './action';
import { getFreeCashBalanceSummary, getFunderAgreementPreSignedUrl, getFunderDetail } from './funder.service';

export function* getFreeCashBalanceSummarySaga() {
    yield execSafeSaga(function* () {
        const freeCash = yield call(getFreeCashBalanceSummary);
        yield put(setFreeCashBalance(freeCash))
    });
}


function* getFunderDetailSaga() {
    yield execSafeSaga(function* () {
        const funderDetail = yield call(getFunderDetail);
        yield put(setFunderDetail(funderDetail));
    });
}

function* getFunderAgreementSaga() {
    yield execSafeSaga(function* () {
        const funderAgreementUrl = yield call(getFunderAgreementPreSignedUrl);
        yield put(setFunderAgreementUrl(funderAgreementUrl));
    })
}

function* pageInitialize() {
    yield execSafeSaga(function* () {
        const store = yield select(state => {
            const { FunderReducer, FunderApplicantReducer } = state;
            return { FunderReducer, FunderApplicantReducer }
        });
        const name = store.FunderReducer.name || store.FunderApplicantReducer.name;
        if (name)
            yield call(getFreeCashBalanceSummarySaga);
        else
            yield all([
                call(getFunderDetailSaga),
                call(getFreeCashBalanceSummarySaga)
            ]);
    });
}

function* rootSaga() {
    yield all([
        takeEvery(actionType.GET_FREE_CASH_BALANCE_SUMMARY, getFreeCashBalanceSummarySaga),
        takeEvery(actionType.GET_FUNDER_DETAIL, getFunderDetailSaga),
        takeEvery(actionType.GET_FUNDER_AGREEMENT, getFunderAgreementSaga),
        takeEvery(actionType.INIT_FUNDER_PAGE, pageInitialize),
    ]);
}

export default rootSaga;